import React, { useEffect, useState } from "react";
import { Button } from "@mui/material";
import { Link } from "react-router-dom";
import { useAuth } from "../auth/AuthContext";
import { MASCOT } from "../utils/mascotBus";

const STORAGE_KEY = "marsilya_welcome_popup_v1";

const WelcomeBonusModal = () => {
  const { user } = useAuth();
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (sessionStorage.getItem(STORAGE_KEY)) return;
    const timer = setTimeout(() => setOpen(true), 1200);
    return () => clearTimeout(timer);
  }, []);

  const close = () => {
    sessionStorage.setItem(STORAGE_KEY, "1");
    setOpen(false);
  };

  if (!open) return null;

  const ctaTo = user ? "/hesabim?tab=deposit" : "/register";

  return (
    <div className="promo-overlay" role="dialog" aria-modal="true" aria-label="Hoşgeldin bonusu">
      <div className="promo-modal">
        <button type="button" className="promo-close" onClick={close} aria-label="Kapat">
          ×
        </button>
        <div className="promo-glow" />
        <img className="promo-mascot" src={MASCOT.tease} alt="" aria-hidden />
        <div className="promo-badge">YENİ ÜYE</div>
        <h2>
          İlk yatırıma özel
          <span>%100 hoşgeldin bonusu</span>
        </h2>
        <p>
          Marsilya&apos;da ilk yatırımını yap, kaybettikten sonra %100 bonus kazan.
          1.000 ₺ bonus için 10.000 ₺ çevirim gerekir. Aviator, Zar, Mayın ve diğer orijinal masalarda geçerlidir.
        </p>
        <ul className="promo-points">
          <li>Minimum yatırım 500 ₺</li>
          <li>Bonus tutarının 10 katı çevirim şartı</li>
          <li>Çevirim bitince çekim talebi açılır</li>
        </ul>
        <div className="promo-actions">
          <Button variant="contained" color="primary" size="large" component={Link} to={ctaTo} onClick={close}>
            {user ? "Hemen yatır" : "Kayıt ol & yatır"}
          </Button>
          <button type="button" className="promo-skip" onClick={close}>
            Daha sonra
          </button>
        </div>
      </div>
    </div>
  );
};

export default WelcomeBonusModal;
